import { useAction } from "../../../../hooks";
import {
    decodeStyle,
    getFileURL,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
// import { getFileURL } from "../../_helper/image";

function IconList({ id, db, gs, device }) {
    const data = db[id];
    const { performAction, currentPage } = useAction();

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const checkSelected = (item) => {
        if (item.action?.type === "page") {
            if (item.action.params?.id === currentPage) {
                return true;
            }
            return false;
        }
        return false;
    };

    function renderChilds() {
        return input.items.map((item, index) => {
            if (item !== "") {
                return (
                    <li
                        key={index}
                        style={{
                            margin: input.itemGap - 0.5 + "rem 0px",
                            cursor:
                                item.action.type === "none"
                                    ? "auto"
                                    : "pointer",
                        }}
                        // onClick={() => onButtonClick(item.action)}
                        onClick={() => performAction(item.action)}
                    >
                        <span>
                            <span
                                className="fa-li"
                                style={{
                                    ...decodeStyle(ps.styleGroup.icon, gs),
                                }}
                            >
                                <i className={item.icon.value}></i>
                            </span>
                            <span
                                style={{
                                    ...decodeStyle(ps.styleGroup.text, gs),
                                    // color: checkSelected(item)
                                    //     ? "cyan"
                                    //     : "inherit",
                                }}
                            >
                                {item.text}
                            </span>
                        </span>
                    </li>
                );
            }
        });
    }

    // const ss = decodeStyle(ps.style, gs);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <ul
                className="fa-ul"
                style={{
                    fontSize: input.iconSize.value,
                    lineHeight: input.iconSize.value,
                    ...decodeStyle(ps.styleGroup.iconList, gs),
                    alignSelf: input.alignList,
                    marginTop: "-8px",
                    marginBottom: "-8px",
                }}
            >
                {renderChilds()}
            </ul>
            {/* <h2 onClick={() => setSelectedElement(id)}>Icon List</h2> */}
        </div>
    );
}

export default IconList;
